import React, { Component } from 'react';
import { ButtonGroup, Button, Radio, Modal } from 'react-bootstrap';

class HelpButton extends Component {
  state: {
    show_modal: boolean
  };

  constructor() {
    super();
    this.state = {
      show_modal: false
    }
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  open() {
    this.setState({show_modal: true});
  }

  close() {
    this.setState({show_modal: false});
  }

  print(printFn) {
    printFn(this.state.selected);
    this.close();
  }

  render(props) {
    return (
      <ButtonGroup>
      <Button className={"xwordjs-help-button"} title="Help" bsSize="xsmall" onClick={this.open}>
        <img src={"images/help.gif"}/>
      </Button>
      <Modal show={this.state.show_modal} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Help</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="xwordjs-print-menu">
        <ul>
          <li>Use the <b>arrow keys</b> to move the cursor to the desired cell.</li>
          <li>Clicking on a clue or in the grid will select the corresponding entry.</li>
          <li><b>Enter</b> and <b>(Shift-)Tab</b> will focus the next (previous) entry.</li>
          <li><b>Backspace</b> and <b>Delete</b> clear existing cells.</li>
          <li><b>Space bar</b> toggles direction.</li>
          <li><b>F5</b> resets the puzzle.</li>
          <li>Type <b>+</b> to enter more than one letter into a cell.  Either the full word or the first letter of a rebus cell will be accepted when checking the puzzle.</li>
        </ul>
        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.close}>OK</Button>
        </Modal.Footer>
      </Modal>
      </ButtonGroup>);
  }
}

export default HelpButton;



// WEBPACK FOOTER //
// ./src/HelpButton.js